import { global } from '../global';
import { paths, pathnames } from '../../paths';

export const marketing = {
  global,
  path: paths.marketing,
  pathname: pathnames[paths.marketing],
  content: {
    sections: [
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          }
        ]
      },

    ]
  }
};
